import { authHeader } from './auth-header'
import axiosInstance from "./client"

export const roleService = {
  getAll,
  createOrUpdate,
  getById,
  deleteById,
}

function getById(roleId) {
  const requestOptions = {
    url: '/api/v1/user/role/' + roleId,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function getAll() {
  const requestOptions = {
    url: '/api/v1/user/role',
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}


function createOrUpdate(jsonData) {
  let formData = new FormData()
  jsonData['ID'] = jsonData['id']
  for (var key in jsonData) {
    if (jsonData[key] != null)
      formData.append(key, jsonData[key])
  }
  let rMethod = jsonData["id"] != null ? "PUT" : "POST"
  const requestOptions = {
    url: '/api/v1/user/role',
    method: rMethod,
    data: formData,
    headers: authHeader()
  }

  return axiosInstance(requestOptions)
}


function deleteById(id) {
  const requestOptions = {
    url: `/api/v1/user/role/` + id,
    method: 'DELETE',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}
